<script>
  import { onMount } from "svelte";
  // core components
  import CardStats from "components/Cards/CardStats.svelte";
  import { getWeather, getExchangeRate, getStockIndices } from "../../api/external.js";

  let weather = { temp: 0, code: 0 };
  let exchange = { rate: 0 };
  let stock = { kospi: 0, sp500: 0 };

  onMount(async () => {
    try {
      const weatherData = await getWeather();
      if (weatherData.current_weather) {
        weather = {
          temp: weatherData.current_weather.temperature,
          code: weatherData.current_weather.weathercode
        };
      }

      const exchangeData = await getExchangeRate();
      if (exchangeData.rates) {
        exchange = { rate: exchangeData.rates.KRW };
      }

      const stockData = await getStockIndices();
      stock = stockData;
    } catch (error) {
      console.error("Failed to fetch dashboard data:", error);
    }
  });

  function getWeatherIcon(code) {
    if (code === 0) return "fas fa-sun";
    if (code >= 1 && code <= 3) return "fas fa-cloud-sun";
    if (code >= 45 && code <= 48) return "fas fa-smog";
    if (code >= 51 && code <= 67) return "fas fa-cloud-showers-heavy";
    if (code >= 71 && code <= 77) return "fas fa-snowflake";
    if (code >= 80 && code <= 99) return "fas fa-cloud-rain";
    return "fas fa-cloud";
  }
</script>

<!-- Header -->
<div class="relative bg-red-500 md:pt-32 pb-32 pt-12">
  <div class="px-4 md:px-10 mx-auto w-full">
    <div>
      <!-- Card stats -->
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="Seoul Temperature"
            statTitle="{weather.temp}°C"
            statArrow="up"
            statPercent="1.2"
            statPercentColor="text-emerald-500"
            statDescripiron="Real-time from Open-Meteo"
            statIconName="{getWeatherIcon(weather.code)}"
            statIconColor="bg-red-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="USD / KRW"
            statTitle="{exchange.rate}"
            statArrow="down"
            statPercent="0.5"
            statPercentColor="text-red-500"
            statDescripiron="Real-time from Frankfurter"
            statIconName="fas fa-money-bill-wave"
            statIconColor="bg-orange-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="KOSPI"
            statTitle="{stock.kospi}"
            statArrow="down"
            statPercent="1.10"
            statPercentColor="text-orange-500"
            statDescripiron="Real-time from Stooq"
            statIconName="fas fa-chart-line"
            statIconColor="bg-pink-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="S&P 500"
            statTitle="{stock.sp500}"
            statArrow="up"
            statPercent="12"
            statPercentColor="text-emerald-500"
            statDescripiron="Real-time from Stooq"
            statIconName="fas fa-percentage"
            statIconColor="bg-emerald-500"
          />
        </div>
      </div>
    </div>
  </div>
</div>
